import EditorAbstractField from "./EditorAbstractField.mjs";
import {Input, InputGroup, InputGroupText, Label} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";
import EditorFieldGroup from "./EditorFieldGroup.mjs";
import React from "react";

const EditorGroup = class extends EditorAbstractField {
	field() {
		return(
			<>
				<InputGroup>
					<InputGroupText>
						<TextLabel value={"Multiple"} />
					</InputGroupText>
					<InputGroupText>
						<Input
							id={this.uid+'isMultiCheckBox'}
							type={"checkbox"}
							checked={ !! this.state.value?.multiple }
							onChange={e => this.setValue('multiple', e.currentTarget.checked || undefined ) }
						/>
					</InputGroupText>
					<InputGroupText>
						<Label htmlFor={this.uid+'isMultiCheckBox'}>
							<TextLabel value={"Multiple fields always return an array"} />
						</Label>
					</InputGroupText>
				</InputGroup>
				<blockquote>
					<EditorFieldGroup
						fields={this.state.value?.fields || []}
						fieldKeys={(this.state.value?.fields || []).filter( f => f?.key ).map(f => f.key)}
						commit={ (v)=> { this.setValue('fields',v); } }
					/>
				</blockquote>
			</>
		);
	}
}

export default EditorGroup;
